import Vue from 'vue';

const showError = error => {
    Vue.toasted.global.toast_error({
        message: error,
    });
};

// TODO handled errors code that displays twice
// REFERENCE https://www.qcode.in/api-error-handling-in-vue-with-axios/
export default async function errorHandler(error) {
    if (error.response) {
        showError(`${error.response.status} ${error.response.statusText}`);

        // Check if error comes from server
        if (error.response.data.error) {
            const errorMessage = error.response.data.error.message;
            showError(`${errorMessage}`);
        }
    } else if (error.request) {
        showError(error.request);
    } else {
        showError(error.message);
    }
    return Promise.reject(error);
}
